import React, {Component, lazy} from 'react'

import {WithTranslation, withTranslation} from 'react-i18next'
import {WithStyles} from '@mui/styles'
import {SvgIcon} from '@mui/material'
import {WarningAmber} from '@mui/icons-material'
import authService from "../../../services/auth";
import {UserType} from "../../../application/domain/utils/user.type";
import {IComponentRouter, withRouter} from '../../with.router'

const EscapePage = lazy(() => import('./escape.component'))

type Props = WithTranslation & IComponentRouter & WithStyles<any>

/**
 * Page that renders access denied escape page.
 * @alias AccessDenied
 * @component
 * @category Components
 * @subcategory Escape Pages
 */
class AccessDeniedComponent extends Component<Props> {

    /**
     * @public
     * @returns {React.ReactNode} Render the escape page.
     */
    public render() {
        const { t, navigate } = this.props
        const token = authService.decodeToken()

        if (token.sub_type !== UserType.ANALYST || token.sub_type !== UserType.ADMIN) {
            return <EscapePage
                image={
                    <SvgIcon
                        titleAccess={t('ESCAPE_PAGE.ACCESS_DENIED.TITLE')}
                        component={WarningAmber}
                        color="primary"
                        sx={{ width: 150, height: 150 }}/>
                }
                title={t('ESCAPE_PAGE.ACCESS_DENIED.TITLE')}
                helmet={t('ESCAPE_PAGE.ACCESS_DENIED.HELMET')}
                description={t('ESCAPE_PAGE.ACCESS_DENIED.DESCRIPTION')}
                action={true}
                actionFunction={() => {
                    authService.logout()
                    navigate('/login')
                }}
                buttonTitle={t('ESCAPE_PAGE.ACCESS_DENIED.LOGOUT')}
            />
        }

        return <EscapePage
            image={
                <SvgIcon
                    titleAccess={t('ESCAPE_PAGE.ACCESS_DENIED.TITLE')}
                    component={WarningAmber}
                    color="primary"
                    sx={{ width: 150, height: 150 }}/>
            }
            title={t('ESCAPE_PAGE.ACCESS_DENIED.TITLE')}
            helmet={t('ESCAPE_PAGE.ACCESS_DENIED.HELMET')}
            description={t('ESCAPE_PAGE.ACCESS_DENIED.DESCRIPTION')}/>
    }
}

const AccessDenied: any = withTranslation()(AccessDeniedComponent)

export default withRouter(AccessDenied)
